import * as React from "react"
import { Search, Bell, HelpCircle, Settings, Sun, Moon } from "lucide-react"
import { useAuthStore } from "@/store"

export default function Header() {
  const user = useAuthStore((s) => s.user)
  const [theme, setTheme] = React.useState('dark')

  return (
    <header style={{ height: 56, background: '#0F172A', borderBottom: '1px solid #1F2937', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', position: 'sticky', top: 0, zIndex: 30 }}>
      {/* Search */}
      <div style={{ position: 'relative', width: 320 }}>
        <Search size={16} color="#64748B" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)' }} />
        <input type="text" placeholder="Search anything..." style={{ width: '100%', height: 40, background: '#111827', border: '1px solid #334155', borderRadius: 10, padding: '0 48px 0 40px', fontSize: 13, color: '#F8FAFC', outline: 'none', transition: 'border 180ms' }} />
        <kbd style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: '#1E293B', border: '1px solid #334155', borderRadius: 4, padding: '2px 6px', fontSize: 11, color: '#64748B' }}>⌘K</kbd>
      </div>

      {/* Right */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <button style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8, background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', transition: 'all 180ms' }}>
          <Settings size={20} />
        </button>
        <button onClick={() => setTheme(t => t === 'dark' ? 'light' : 'dark')} style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8, background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', transition: 'all 180ms' }}>
          {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
        </button>
        <button style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8, background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', position: 'relative', transition: 'all 180ms' }}>
          <Bell size={20} />
          <span style={{ position: 'absolute', top: 6, right: 6, width: 18, height: 18, borderRadius: '50%', background: '#EF4444', color: '#fff', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>12</span>
        </button>
        <button style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8, background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', transition: 'all 180ms' }}>
          <HelpCircle size={20} />
        </button>
        <div style={{ marginLeft: 8, display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', borderRadius: 8, border: '1px solid #1F2937', cursor: 'pointer' }}>
          <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#3B82F6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#fff' }}>
            {user?.username?.charAt(0)?.toUpperCase() || 'KA'}
          </div>
        </div>
      </div>
    </header>
  )
}
